import React, {Component} from 'react';
import Global from '../../../Global';
import Search from '../Search';


import SwipeableViews from 'react-swipeable-views';
import {virtualize} from 'react-swipeable-views-utils';
import {mod} from 'react-swipeable-views-core';

const VirtualizeSwipeableViews = virtualize(SwipeableViews);

class Carousel extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            index: 0,
            // isAutoPlay: this.props.items.length > 1,
            isAutoPlay: false,
            numOfSlides: this.props.items.length
        }
    }

    getDots() {
        const {state} = this;
        let html = [];

        for (var i = 0; i < state.numOfSlides; i++) {
            html.push(<span key={i} className={state.index === i ? 'active' : ''}>{i}</span>);
        }
        return html;
    }


    transitionEnd(index) {
        const {state: {numOfSlides}} = this;
        index = ((index % numOfSlides) < 0) ? (index % numOfSlides + numOfSlides) : (index % numOfSlides);
        this.setState({
            index: index
        });
    }

    slideRenderer(params) {
        // Protection when no data from caller.
        if (!this.props.items || !this.props.items.length) {
            return null;
        }

        const {state: {numOfSlides}} = this;
        const {index, key} = params;
        const slideIndex = ((index % numOfSlides) < 0) ? (index % numOfSlides + numOfSlides) : (index % numOfSlides);
        return (
            <div className={"searchImgSlider"}
                // style={{ "backgroundImage": "url(" + this.props.items[slideIndex] + ")" ,backgroundSize:"cover"}}
                 key={key}>
                <img
                    src={this.props.items[slideIndex]}
                />
            </div>
        );
    }

    render() {
        // let index = this.state.index
        // let key = index
        return (
            [<VirtualizeSwipeableViews
                // autoplay={this.state.isAutoPlay}
                enableMouseEvents
                className="carousel"
                slideRenderer={this.slideRenderer.bind(this)}
                onChangeIndex={this.transitionEnd.bind(this)}
            ></VirtualizeSwipeableViews>,
                // <div>
                //   {this.slideRenderer({index,key})}
                // </div>
                <div className="dots" key="getdots">
                    {(this.state.numOfSlides > 2) && this.getDots()}
                </div>]
        );
    }
}

class SearchMobile extends Search {
    constructor(props) {
        super(props)
        this.handleSearchSubmit = this.handleSearchSubmit.bind(this)
    }

    getQuickLinksBlockHTML() {
        let quicekLink = this.state.searchData.column1
        return (
            <div className="quick-links-block">
                <span class="title">{quicekLink.title}</span>
                <div className="row">
                    {quicekLink.items.map((item, index) => {
                        return <li key={index}>
                            <a href={item.url}>{item.label}</a>
                        </li>
                    })}
                </div>
            </div>
        );

    }

    searchResultsHTML() {
        return (
            <div className="section-search-result">
                <div className="col-xs-12 section-search-result-wrapper">
                    <div className="row">
                        <div className="col-xs-12 search-result-category-heading">
                            {this.getSearchResultsCategories()}
                        </div>
                    </div>
                    <div className="row">
                        <div className="search-result-list">
                            <div className="search-result-panel">
                                {this.getSearchResultsHTML()}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    getSearchResultsHTML() {

        // filter by category

        return this.props.searchResultStates.searchResultsData.searchResults.map((result, index) =>
            (this.getSearchResultsByCategory(result.category) ?
                    <div key={index} className="row search-result">
                        <div className="thumbnail">
                            {result.img !== "" &&
                            <img className="img-responsive" src={result.img} alt={result.alt}/>
                            }
                        </div>
                        <div className="search-result-body">
                            <a href={result.url}><span class="title">{result.title}</span></a>
                            <p>
                                {result.summary}
                            </p>
                        </div>
                    </div>

                    :
                    ""
            )
        );
    }

    /*
    Search AJAX
    */

    handleSearchSubmit(e) {
        let searchTerm = document.getElementById('mobile-search-input').value;

        this.setState({
            searchLoading: true
        }, function () {

            // do the ajax

            var url = window.THREE_REACT_APP_GLOBAL.api_endpoint + window.THREE_REACT_APP_GLOBAL.language + "/search-results.json?search=" + encodeURIComponent(searchTerm);
            var self = this;
            fetch(url)
                .then(function (response) {
                    if (response.status >= 400) {
                        throw new Error("Error API: search results");
                    }
                    return response.json();
                })
                .then(function (data) {

                    if (data.searchResults.length > 0) {
                        self.setState({
                            //searchResultsData: data,
                            //searchNotFound: false,
                            searchLoading: false
                        }, function(){
                            self.props.setSearchResultStates(data, false)
                        });

                    } else {
                        self.setState({
                            //searchResultsData: data,
                            //searchNotFound: true,
                            searchLoading: false
                        }, function(){
                            self.props.setSearchResultStates(data, true)
                        });

                    }
                });

        });

    }

    /*
    Search Loading
    */
    componentWillMount() {

        // FETCH JSON

        var url = Global.getAPI('search');
        var self = this;
        fetch(url)
            .then(function (response) {
                if (response.status >= 400) {
                    throw new Error("Error API: search");
                }
                return response.json();
            })
            .then(function (data) {

                // let's split the trending array into groups of 2 for easier HTML rendering

                self.setState({
                    searchData: data,
                }, function () {
                    window.THREE_MAIN.search.init();
                });

            });

    }

    getTrendingNowBlockHTML() {
        let searchData = this.state.searchData;
        var trendingArray = searchData.trending.items;

        // console.log(searchData.trending)
        if (trendingArray.length) {
            return (
                <div className="trending-now-block">
                    <span class="title">{searchData.trending.title}</span>
                    <Carousel
                        items={searchData.trending.items.map(e => e.src)}
                    />
                </div>
            );

        } else {
            return false;
        }

    }

    render() {

        if (Object.keys(this.state.searchData).length === 0) {
            return false;
        }
        else {
            let searchResultStates = this.props.searchResultStates;

            // console.log(searchResultStates);

            return (
                <div id="search-mobile" className="search-mobile">
                    <div className="container">
                        {!this.state.searchLoading && searchResultStates.searchResultsData.searchResults.length == 0 && !searchResultStates.searchNotFound &&
                        <div className="row">
                            <div className="content-container">
                                <div className="section-search-default">
                                    {this.getQuickLinksBlockHTML()}
                                    {this.getTrendingNowBlockHTML()}
                                </div>
                            </div>
                        </div>}{/* row END */}

                        {this.state.searchLoading &&
                        this.searchLoadingHTML()
                        }

                        {searchResultStates.searchResultsData.searchResults.length > 0 &&
                        this.searchResultsHTML()
                        }

                        {searchResultStates.searchNotFound &&
                        this.searchNotFoundHTML()
                        }

                    </div>
                </div>
            );
        }

    }
}

export default SearchMobile;
